import React from "react";

const LoadingRing = () => {
  return (
    <div className="tm-flex tm-items-center tm-justify-center">
      <div className="tm-animate-spin tm-rounded-full tm-h-4 tm-w-4 tm-border-[2px] tm-border-t-transparent tm-border-white"></div>
    </div>
  );
};

export default LoadingRing;
